
/*

----- Axis Equalise ----- 
This is a replacement for Foundation's equalise plugin https://get.foundation/sites/docs/equalizer.html as it really doesn't handle nested equalised instances very well and requires quite a bit of additional markup to function, for very simple applications it is fine but when you are equalising multiple elements suchs collection descriptions, various pricing values, images and specifications across a collection it starts to get itself in knots pretty quickly.
- This will handle both X and Y ( width & height ) equalisiation, currently not at the same time though.
- Equalisation by row.

*/



// TODO: Need some time to clean up instances after ajax.
function initialiseAll() {
    $('[data-equalise-container]').each(function () {
        // Grab context.
        let context = $(this);
        // Initialise.
        let init = initialise(context);
    });
}


function initialise(context) {
    // Container context.
    let container = context;

    let id = generateId();

    container.attr('data-equalise-container', id);

    // Create group instance.
    instances[id] = {};

    // Equalise by row.
    let byRow = context.attr(expressSelectors()['equaliser']['by-row']);
    // Default to this otherwise you will get odd white spaces in the grid.
    if (byRow == undefined) {
        byRow = true;
    } else {
        // Convert string to boolean.
        byRow = (byRow == "true");
    }

    // Should we qualise by min value.
    let equaliseByMin = (context.attr(expressSelectors()['equaliser']['equalise-by-min']) != undefined);
    
    // Equalise x axis ( width ).
    let equaliseByX = (context.attr(expressSelectors()['equaliser']['equalise-x']) != undefined);
    //console.log(equaliseByX)

    // If the content is a carousel then don't equalise by row.
    if (container.find('[' + expressSelectors()['axis-carousel']['initialise']  + ']').length > 0) {
        byRow = false;
    }

    // Get starting breakpoint.
    let breakpoint = context.attr(expressSelectors()['equaliser']['breakpoint']);

    container.find('['+ expressSelectors()['equaliser']['group-id'] + ']:not([data-equalizer-watch])').each(function () {
        // Element context.
        let element = $(this);
        // Group Id.
        let groupId = element.attr(expressSelectors()['equaliser']['group-id']);
        if (!groupId) {
            console.error("Element has no group id.", element);
            return false;
        }
        
        if (!instances[id].hasOwnProperty(groupId)) {
            instances[id][groupId] = {};
            instances[id][groupId]['items'] = [];
            // instances[id][groupId]['by-row'] = byRow;
            // Should we be equalising the x axis instead of the y
            if (element.attr(expressSelectors()['equaliser']['by-row']) != undefined) {
                // If this group have specific config.
                instances[id][groupId]['by-row'] = (element.attr(expressSelectors()['equaliser']['by-row']) == "true");
            } else {
                // Fallback to container config if no group config.
                instances[id][groupId]['by-row'] = byRow;
            }

            // Should we be equalising the x axis instead of the y
            if (element.attr(expressSelectors()['equaliser']['equalise-x']) != undefined) {
                // If this group have specific config.
                instances[id][groupId]['equalise-x'] = true;
            } else {
                // Fallback to container config if no group config.
                instances[id][groupId]['equalise-x'] = equaliseByX;
            }
            // Equalise by min.
            if (element.attr(expressSelectors()['equaliser']['equalise-by-min']) != undefined) {
                instances[id][groupId]['by-min'] = true;
            } else {
                 // Fallback to container config if no group config.
                 instances[id][groupId]['by-min'] = equaliseByMin;
            }

            if (element.attr(expressSelectors()['equaliser']['breakpoint']) != undefined) {
                instances[id][groupId]['breakpoint'] = element.attr(expressSelectors()['equaliser']['breakpoint']);
            } else {
                // Fallback to container config.
                instances[id][groupId]['breakpoint'] = breakpoint;
            }
        }

        // Add item to array.
        instances[id][groupId]['items'].push(element);
    });

    // This fix is based on optimizitor's answer here https://stackoverflow.com/questions/20613984/jquery-or-javascript-check-if-image-loaded but utilising a promise.
    let isImagesLoaded = new Promise((resolve, reject) => {
        let images = container.find('img');
        if (!images.length) {
            resolve();
        } else {
            let notLoadedCount = 0;
            // Check to make sure all images are loaded.
            images.each(function() {
                // Image context.
                let image = $(this);

                image = image[0];
                
                // Is loaded?
                let isLoaded = image.complete;
                if (!isLoaded) {
                    notLoadedCount++
                    image.addEventListener('load', function() {
                        // Once last image is loaded then run equalisation.
                        if (images[images.length - 1] == image) {
                            resolve();
                        }
                    });
                }
            });
            // Everything is load run equalsiation.
            if (!notLoadedCount) {
                resolve();
            }
        }
    });
    // Make sure content is loaded first ( i.e ajax'd in content ).
    isImagesLoaded.then(() => {
        // Initialise each group.
        $.each(instances[id], function (groupId) {
            // Get group config.
            let config = instances[id][groupId];
            // Do the item equalisation.
            let eq = equalise(config);

            // Responsive aspect.
            // TODO: this need re-thinking. #825975
            // $(window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
            //     eq = equalise(config);
            // });

            // Adding throttle as this functionality was being triggered too soon and not allowing the viewport to fully resize before triggering as suggested by Foundation's documentation https://get.foundation/sites/docs/javascript-utilities.html#throttle.
            $(window).on('changed.zf.mediaquery', Foundation.util.throttle(function(event) {
                eq = equalise(config);
            }, 1000));
        });
        // Create an observer for any classes that are changed in the sub tree then re-equalise. Scoped to affected groups only to avoid forcing layout recalculation on unaffected groups.
        let observerRAFId = null;
        let pendingMutations = [];
        let observer = new MutationObserver(function(mutations) {
            for (let item = 0; item < mutations.length; item++) {
                pendingMutations.push(mutations[item]);
            }
            if (observerRAFId) {
                return;
            }
            // Using requestAnimationFrame rather than setTimeout to coalesce multiple synchronous mutations into a single equalisation pass without introducing an arbitrary delay.
            // rAF defers the work to just before the next paint which yields back to the browser so the current frame's rendering is not blocked, a setTimeout would require a magic number delay that would not be appropriate here as this observer is not specific to any one component ( accordion, carousel, tabs, etc ).
            observerRAFId = requestAnimationFrame(function() {
                observerRAFId = null;
                // Collect unique affected group ids from the mutation targets.
                let affectedGroupIds = {};
                for (let item = 0; item < pendingMutations.length; item++) {
                    let target = pendingMutations[item].target;
                    // Check if the target itself is an equalise group item.
                    let groupId = target.getAttribute(expressSelectors()['equaliser']['group-id']);
                    if (groupId && instances[id].hasOwnProperty(groupId)) {
                        affectedGroupIds[groupId] = true;
                    }
                    // Check for equalise group items within the target's subtree.
                    let children = target.querySelectorAll('[' + expressSelectors()['equaliser']['group-id'] + ']');
                    for (let group = 0; group < children.length; group++) {
                        let childGroupId = children[group].getAttribute(expressSelectors()['equaliser']['group-id']);
                        if (childGroupId && instances[id].hasOwnProperty(childGroupId)) {
                            affectedGroupIds[childGroupId] = true;
                        }
                    }
                }
                pendingMutations = [];
                // Re-equalise only the affected groups.
                let groupKeys = Object.keys(affectedGroupIds);
                for (let item = 0; item < groupKeys.length; item++) {
                    equalise(instances[id][groupKeys[item]]);
                }
            });
        });

        // Observer config.
        observer.observe(context[0], {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
        // Trigger initialised event.
        context.trigger('equaliser-initialised', id);
    }).catch((error) => console.error(error));
}

function doCleanup(config, elements) {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Equaliser: Current breakpoint is less than min breakpoint, skipping equalisation", config);
    }
    // Run clean up just incase we're resizing.
    for (let item = 0; item < elements.length; item++) {
        itemCleanup(config, elements[item]);
    }
}

function equalise(config) {
    // Unwrap jQuery objects to native elements once upfront, this avoids repeated [0] access throughout
    // equalisation and allows us to use native DOM APIs ( getBoundingClientRect, style, offsetParent )
    // which are faster than their jQuery equivalents ( .offset(), .outerHeight(), .css() ).
    let items = config['items'];
    let elements = [];
    for (let item = 0; item < items.length; item++) {
        elements.push(items[item][0]);
    }
    // Equalise by row.
    let byRow = config['by-row'];
    let equaliseByX = config['equalise-x'];
    // Equalise by min value.
    let equaliseByMin = config['by-min'];
    // Get starting breakpoint.
    //let minBreakpoint = config['breakpoint'];
    let breakpointConfig = (config['breakpoint'] ? config['breakpoint'].split(" ") : undefined);
    // This is modelled off of https://get.foundation/sites/docs/media-queries.html.
    if (breakpointConfig) {
        // Get breakpoint.
        let breakpoint = breakpointConfig[0];
        // Convert breakpoint string to int.
        breakpoint = getBreakpoint(breakpoint);
        // // Get operator.
        let operator = (breakpointConfig.length > 1 ? breakpointConfig[1] : undefined);
        // // Get current viewport breakpoint.
        let getCurrentBreakpoint = currentBreakpoint();
        // If an operator is provided ( small only || medium down || large up ) essentialy secondary parameter to the breakpoint attribute.
        if (operator) {
            switch(operator) {
                case "only": 
                    if (getCurrentBreakpoint != breakpoint) {
                        if (AXISDebug.level() >= 3) {
                            AXISDebug.output(1,"Equaliser: Cleaning up, configured breakpoint not equal to current breakpoint", config);
                        }
                        doCleanup(config, elements);
                        return false;
                    }
                    break;
                case "up":
                    if (breakpoint > getCurrentBreakpoint) {
                        if (AXISDebug.level() >= 3) {
                            AXISDebug.output(1,"Equaliser: Cleaning up, configured breakpoint under current breakpoint", config);
                        }
                        doCleanup(config, elements);
                        return false;
                    }
                    break;
                case "down":
                    if (getCurrentBreakpoint > breakpoint) {
                        if (AXISDebug.level() >= 3) {
                            AXISDebug.output(1,"Equaliser: configured breakpoint over current breakpoint", config);
                        }
                        doCleanup(config, elements);
                        return false;
                    }
                    break;
                default:
                    console.error("Equaliser: Sorry we don't currently support that operator", operator);
                    return false;
            }
        } else {
            // Fallback to standard behavour.
            // If current breakpoint is less than min then exit equalisation, do a cleanup just incase equalisation has previously run and this is a change of viewport to a breakpoint that doesn't require equalisation.
            if (getCurrentBreakpoint < breakpoint) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Equaliser: Current breakpoint is less than min breakpoint, skipping equalisation", config);
                }
                doCleanup(config, elements);
                return false;
            }
        }
    }

    // Filter to visible items only, no point equalising items inside collapsed accordion sections as dimensions will be inaccurate.
    let visibleItems = [];
    for (let item = 0; item < elements.length; item++) {
        // offsetParent is null for hidden elements.
        if (elements[item].offsetParent !== null) {
            visibleItems.push(elements[item]);
        }
    }

    // Nothing visible, skip equalisation.
    if (!visibleItems.length) {
        return;
    }

    // --- Batch cleanup pass (write) ---
    // Reset all heights / widths before measuring to prevent previous values from being carried forward.
    for (let item = 0; item < visibleItems.length; item++) {
        itemCleanup(config, visibleItems[item]);
    }

    // --- Batch measure pass (read) ---
    // Collect all measurements before writing any values back to avoid layout thrashing.
    // Using getBoundingClientRect for a single call that returns top, width and height.
    let measurements = [];
    for (let item = 0; item < visibleItems.length; item++) {
        let element = visibleItems[item];
        let rect = element.getBoundingClientRect();
        let measurement = { 'element': element };
        if (byRow) {
            // Use pageYOffset to convert from viewport-relative to document-relative.
            let top = rect.top + window.pageYOffset;
            // Round to nearest hundred, this should help iron out any inconsistencies in the styling / content height ( e.g External data images ).
            top = Math.round( top / 100) * 100;
            measurement['top'] = top;
        }
        if (equaliseByX) {
            measurement['value'] = Math.ceil(rect.width);
        } else {
            measurement['value'] = Math.ceil(rect.height);
        }
        measurements.push(measurement);
    }

    // --- Batch apply pass (write) ---
    // Build rows from measurements and apply equalised values.
    let row = [];
    let max = null;
    let position = "";

    for (let item = 0; item < measurements.length; item++) {
        let measurement = measurements[item];
        if (byRow) {
            // New row.
            if (measurement['top'] != position) {
                // Apply values for the previous row before starting a new one.
                applyValues(row, max, equaliseByX);
                // Override last item position.
                position = measurement['top'];
                // Reset max.
                max = 0;
                // Reset row array.
                row = [];
            }
        }
        // Add item to row array.
        row.push(measurement['element']);
        if (equaliseByX) {
            if (equaliseByMin) {
                if (max == null) {
                    max = measurement['value'];
                }
                max = Math.min(max, measurement['value']);
            } else {
                max = Math.max(max, measurement['value']);
            }
        } else {
            max = Math.max(max, measurement['value']);
        }
        // Round max up.
        max = Math.ceil(max);
    }

    // Apply values for the final row.
    applyValues(row, max, equaliseByX);
    // set max height in instance.
    config['equalise-value'] = max;
}

// Apply equalised values to a row of items.
function applyValues(row, max, equaliseByX) {
    if (!row.length || max == null) {
        return;
    }
    let maxPx = max + 'px';
    if (equaliseByX) {
        for (let item = 0; item < row.length; item++) {
            let element = row[item];
            element.style.width = maxPx;
            if (element.style.flexGrow) {
                // If we're setting a width then you cannot have flex-grow set ( the two contradict each other )
                element.style.flexGrow = 0;
                element.style.flexBasis = 'auto';
            }
        }
    } else {
        for (let item = 0; item < row.length; item++) {
            row[item].style.height = maxPx;
        }
    }
}

// Items CSS Cleanup, this has to be done before equalisation otherwise previous width's will be carried forward.
function itemCleanup(config, element) {
    // Which axis are we equalising?
    let equaliseByX = config['equalise-x'];
    if (equaliseByX) {
        element.style.width = '';
        if (element.style.flexGrow) {
            element.style.flexGrow = '';
        }
    } else {
        element.style.height = '';
    }
}


var instances = {};



var equaliser = $.equaliser = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    }, 
    equalise: (context) => {
        // Get config.
        let id = context.attr(expressSelectors()['equaliser']['initialise']);
        if (!id) {
            console.error("Equaliser: Could not find instance id for this element", context);
            return false;
        } 
        // Loop through all groups and get configs.
        $.each(instances[id], function(key, config) {
            let eq = equalise(config);
        });
    },
    equaliserActive: (context) => {
        return isEqualiserActive(context);
    }
}

function isEqualiserActive(context) {
    return new Promise((resolve, reject) => {
        // Instance id.
        let id = context.attr(expressSelectors()['equaliser']['initialise']);
        if (id == "") {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"Equaliser: Not initialised yet, waiting for initialisation process to complete.",  context);
            }
            context.on('equaliser-initialised', function(event, id) {
                resolve({
                    "is-active": true,
                    "instance-id": id
                });
                context.off('equaliser-initialised');
            });
        } else {
            // Check to make sure instance is active
            let isActive = instances.hasOwnProperty(id);
            resolve({
                "is-active": isActive,
                "instance-id": id
            });
        }
    });
}


export { equaliser };